// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { FetchModelResponse, IFetchModel } from '@cian/http-api';
import type { IGetRecommendationsResponseV2 } from '../../../entities/recommendations/GetRecommendationsResponseV2';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export interface IMobileSiteGetRecommendationsRequest {
  /** Тип лэндинга **/
  landingType: EQueryParameters;
  /** Источник ликвидности для CPC и генерации токенов **/
  liquiditySource?: string;
  /** Номер страницы для пагинации (нумерация с 0) **/
  page?: number;
  /** Id региона пользователя **/
  regionId: number;
}

export enum EQueryParameters {
  /** Купить — квартиру во вторичке **/
  'SecondaryFlatSale' = 'secondaryFlatSale',
  /** Загородка — купить дом, дачу, таунхаус, участок **/
  'SuburbanSale' = 'suburbanSale',
  /** Посуточно — снять квартиру посуточно **/
  'FlatRentForDay' = 'flatRentForDay',
  /** Снять — квартиру на долгий срок **/
  'FlatRent' = 'flatRent',
  /** Главная cian.ru **/
  'MainPage' = 'mainPage',
}
export type IMobileSiteGetRecommendationsResponse200 = FetchModelResponse<200, 'json', IGetRecommendationsResponseV2>;

export type IMobileSiteGetRecommendationsResponse400 = FetchModelResponse<400, 'json', IErrorResponseSchema>;

export type TMobileSiteGetRecommendationsResponse =
  | IMobileSiteGetRecommendationsResponse200
  | IMobileSiteGetRecommendationsResponse400;

export type TMobileSiteGetRecommendationsModel = IFetchModel<
  IMobileSiteGetRecommendationsRequest,
  undefined,
  TMobileSiteGetRecommendationsResponse
>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetRecommendationsResponseV2, headers: Headers): TResponse200;
  400(response: IErrorResponseSchema, headers: Headers): TResponse400;
}
